/* biome-ignore-all lint/suspicious/noExplicitAny: legacy data structure */
import type { Response, CollectionResponse, PageQueryParams } from "@/types/global"
import { HttpRequest } from "@/utils/request"

export interface HeadwordSearchParams extends PageQueryParams {
  search?: string
  status?: number
}

export interface HistoryRecord {
  filename: string
  createdAt: string
  size: number
}

export interface HeadwordApiParams {
  page: number
  limit: number
  status?: number
  search?: string
}

export const headwordService = {
  list(params: HeadwordApiParams) {
    return HttpRequest.get("v1/head-words", {
      searchParams: params as any,
    }).json<CollectionResponse>()
  },

  detail(id: number) {
    return HttpRequest.get(`v1/head-words/${id}`).json<Response>()
  },

  getHistories(id: number) {
    return HttpRequest.get(`v1/head-words/${id}/history`).json<Response<HistoryRecord[]>>()
  },

  getHistoryDetail(id: number, filename: string) {
    return HttpRequest.get(`v1/head-words/${id}/history/${filename}`).json<Response>()
  },

  update(id: number, data: any) {
    return HttpRequest.put(`v1/head-words/${id}`, {
      json: data,
    }).json<Response>()
  },
}
